// extracted by mini-css-extract-plugin
export default {"headerMenu":"Header2_headerMenu__QBNOU","darkModeTooltip":"Header2_darkModeTooltip__bH6UY","darkModeToggle":"Header2_darkModeToggle__TnlVk"};